import { c as _c } from "react/compiler-runtime";
/**
 * @file BadgeComponent.tsx
 * @description
 * -----------------------------------------------------
 * Componente de Badge
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-11-25
 * @author DLTCode
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

import { HTMLProps } from "react";
import clsx from "clsx";
export type BadgeVariant = "tertiary" | "icy-aqua" | "soft-cyan" | "pine-blue" | "bronze" | "silver" | "gold" | "lilac" | "purple" | "extreme" | "red" | "orange" | "green" | "soft" | "gold" | "primary" | "gray";
export interface BadgeComponentProps extends HTMLProps<HTMLSpanElement> {
  variant?: BadgeVariant;
  width?: "auto" | "full";
}
export default function BadgeComponent(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      variant: t1,
      width: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const variant = t1 === undefined ? "tertiary" : t1;
  const width = t2 === undefined ? "auto" : t2;
  const t3 = `badge--${variant}`;
  const t4 = width !== "auto" && `badge--${width}`;
  let t5;
  if ($[6] !== className || $[7] !== t3 || $[8] !== t4) {
    t5 = clsx("badge", t3, t4, className);
    $[6] = className;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== props || $[12] !== t5) {
    t6 = <span {...props} className={t5}>{children}</span>;
    $[10] = children;
    $[11] = props;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}